import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import _ from 'underscore';

import {Owner} from 'auth/PermissionConstants';
import {EntitySummary} from 'constants/UserConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isRequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import SchemaOwnerDropdown from 'results/assay-schemas/SchemaOwnerDropdown';
import {SchemaInterface} from 'schemas/schema-interface/SchemaInterfaceConstants';
import {StudySchemaQuery} from 'studies/study-schemas/__generated/StudySchemaQuery';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

import {RequestTaskSchemaGraphQL} from '../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';

type StudySchema = ExtractByTypename<StudySchemaQuery['studySchema'], 'StudySchemaNode'>;

interface SchemaOwnerDisplayProps {
  ownerId?: string;
  ownerChoices?: Array<Owner> | null;
  onOwnerChange: (owner: EntitySummary) => void;
  schema?: AssaySchema | RequestTaskSchemaGraphQL | SchemaInterface | StudySchema | null;
  dataTestAttrs?: DataTestAttrs;
  ownerLabel?: string;
}

export default function SchemaOwnerDisplay(props: SchemaOwnerDisplayProps): JSX.Element {
  const {dataTestAttrs, onOwnerChange, ownerChoices, ownerId, ownerLabel = 'Owner', schema} = props;
  if (schema == null) {
    return (
      <SchemaOwnerDropdown
        ownerChoices={ownerChoices ?? []}
        className={css(styles.ownerDropdown)}
        owner={ownerChoices?.find((owner) => owner.id === ownerId) || null}
        onOwnerChanged={onOwnerChange}
        ownerLabel={ownerLabel}
      />
    );
  }

  const organization = isRequestTaskSchema(schema) ? schema.organizationJson : schema.organization;

  return (
    <InputWrapper id={_.uniqueId('ownerName')} label={ownerLabel} labelStyle={FieldLabel.STYLES.LABEL}>
      <span className="settingsPageContainer-readOnlyValue" {...getTestProps(dataTestAttrs)}>
        {organization.name}
      </span>
    </InputWrapper>
  );
}

const styles = StyleSheet.create({
  ownerDropdown: {
    flex: 1,
  },
});
